import { render } from "./PhotoGalleryList.vue?vue&type=template&id=d3dd2330&scoped=true"
import script from "./PhotoGalleryList.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryList.vue?vue&type=script&lang=js"

import "./PhotoGalleryList.vue?vue&type=style&index=0&id=d3dd2330&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3dd2330"]])

export default __exports__